export default __webpack_public_path__ + "static/media/warning.ba7cdd17.png";